/**
 * Featured toolkit names for the toolkit picker.
 * These appear in a highlighted "Featured MCP Servers" section when not searching.
 * Matching is case-insensitive.
 */
export const FEATURED_TOOLKITS = [
  "Gmail",
  "GoogleCalendar",
  "GoogleDocs",
  "Github",
  "Slack",
  "Jira",
] as const;

export type FeaturedToolkit = (typeof FEATURED_TOOLKITS)[number];
